import { DescendantExecuteContext } from 'views/Aide/Scenario/PolicyForm/share';
import { CustomSlateNodeType } from '../types';

export const removeSticker = (item: DescendantExecuteContext['content'][0]) => {
  if (item.type === CustomSlateNodeType.IMAGE && item.children[0].text === 'sticker') {
    return false;
  }
  return true;
};

export const removeParagraph = (item: DescendantExecuteContext['content'][0]) => {
  if (item.type === CustomSlateNodeType.PARAGRAPH) {
    return false;
  }
  return true;
};
